import React, {Component} from 'react';
const { connect } = require('react-redux');
import Modal from 'react-bootstrap-modal';

import ModalBecomeXXL from './ModalBecomeXXL';

import {Form, ErrorContainer} from 'form';

import {t} from 'l10n';

import '../../sass/modals/modalChangeNickName.scss';

import {changeNick} from 'backend-helpers/member';
import {nickChangeRequestSent} from 'reducers/member';

class ModalChangeNickName extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        let {closeFn, nickChangeRequestSent} = this.props;

        changeNick(formData)
            .then(({newNick}) => {
                nickChangeRequestSent(newNick);
                closeFn();
            })
            .catch((error) => {
                setErrors(error.message)
            });
    }

    render() {
        const {show, closeFn, currentUser} = this.props;

        if (!currentUser.isXXL()) {
            return <ModalBecomeXXL show={show} closeFn={closeFn}/>
        }

        return (
            <div>
                <Modal className="changeNameModal" show={show} onHide={closeFn}>
                    <Modal.Body>
                        <div className="close" onClick={closeFn}></div>
                        <p className="modal-title">{t('Change nickname')}</p>
                        <div className="form">
                            <Form onSubmit={this.onSubmit}>
                                <ErrorContainer data-errorcontainer={true} />

                                <div className="form-group">
                                    <label>{t('New nick:')}</label>
                                    <input name="nick" type="text" />
                                </div>
                                <div className="form-group">
                                    <p>{t('Your request will be rejected in the following cases:')}</p>
                                    <p>{t('- Nick vulgar or disrespectful.')}</p>
                                    <p>{t('- Referring to a trademark or a personality.')}</p>
                                    <p>{t('- Nick is in capital letters.')}</p>
                                    <p>{t('- Nick already exists.')}</p>
                                </div>
                                <div className="form-group-buttons">
                                    <button type="submit" className="save-name">{t('Save')}</button>
                                    <button type="button" className="close-name" onClick={closeFn}>{t('Cancel')}</button>
                                </div>
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser
    }),
    {
        nickChangeRequestSent: nickChangeRequestSent
    })
(ModalChangeNickName);


// WEBPACK FOOTER //
// ./src/components/modals/ModalChangeNickName.js